<template>
  <Modal
    actions
    name="APPOINTMENT_CHARGEBACK_MODAL"
    :title="$t('financial.updatePayments.chargeback.modalTitle')"
  >
    <template v-slot:body>
      <v-form ref="paymentForm">
        <HCheckbox
          v-model="usePreviousContract"
          :label="$t('financial.updatePayments.label.useOriginalContract')"
        />
      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn @click="closeModal" class="mr-5" elevation="0" large>
        {{ $t('create.cancel') }}
      </v-btn>
      <v-btn
        @click="save"
        :loading="isLoading"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('create.refund') }}
      </v-btn>
    </template>
  </Modal>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import Modal from '@/components/app/Modal'
import HCheckbox from '@/components/app/HCheckbox'

export default {
  name: 'Chargeback',

  props: {
    payment: {
      required: true,
    },

    appointmentId: {
      required: true,
    },
  },

  components: {
    HCheckbox,
    Modal,
  },

  data() {
    return {
      isLoading: false,
      usePreviousContract: false,
    }
  },

  computed: {
    ...mapGetters(['chargeBackDialog', 'appointment']),

    requestBody() {
      return {
        appointment_id: this.appointmentId,
        payment_to_chargeback_id: this.payment.id,
        use_previous_contract: this.usePreviousContract,
      }
    },
  },

  methods: {
    ...mapActions(['chargebackPayment']),
    ...mapMutations(['closeAllModals']),

    save() {
      Promise.resolve(this.chargebackPayment(this.requestBody)).finally(
        () => (this.isLoading = false)
      )
    },

    closeModal() {
      this.closeAllModals()
    },
  },
}
</script>
